export const note = {
    state: {
        status: 'idle'
    },
    mutations: {
        SET_NOTE_STATUS(state, status) {
            state.status = status
        }
    },
    actions: {
        submitNote({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                // prevent multiple requests at same time
                if(state.status === 'saving') {
                    return
                }
                commit('SET_NOTE_STATUS', 'saving')
                return this.$api.post(`api/${payload.model}/note/${payload.id}.json`, { note: payload.note }).then((response) => {
                    commit('SET_NOTE_STATUS', 'idle')
                    resolve()
                }).catch(error => {
                    commit('SET_NOTE_STATUS', 'error')
                    reject(error)
                })
            })
        }
    },
    getters: {
        noteStatus: (state) => {
            return state.status
        }
    }
}
